import React from 'react'
import { QuestionCardStyles } from '../PreviewStyle'
import AnswerOption from './AnswerOption'

const QuestionCard = ({ question, questionNumber }) => {
    const { text, answer_defs = [] } = question
    return (
        <QuestionCardStyles>
            <div className="question-header">
                <span className="question-number">{questionNumber}.</span>
                <span className="question-text">{text}</span>
            </div>
            <div className="answers-list">
                {answer_defs.map((answer) => (
                    <AnswerOption key={answer.id} answer={answer} />
                ))}
            </div>
        </QuestionCardStyles>
    )
}

export default QuestionCard
